export const FETCH_CUSTOM_GROUPS = 'FETCH_CUSTOM_GROUPS';
export const FETCH_CUSTOM_GROUPS_SUCCESS = 'FETCH_CUSTOM_GROUPS_SUCCESS';
export const FETCH_CUSTOM_GROUPS_FAILURE = 'FETCH_CUSTOM_GROUPS_FAILURE';
export const FETCH_CUSTOM_GROUP_ITEMS = 'FETCH_CUSTOM_GROUP_ITEMS';
export const FETCH_CUSTOM_GROUP_ITEMS_SUCCESS = 'FETCH_CUSTOM_GROUP_ITEMS_SUCCESS';
export const FETCH_CUSTOM_GROUP_ITEMS_FAILURE = 'FETCH_CUSTOM_GROUP_ITEMS_FAILURE';
export const CLEAR_CREATED_CUSTOM_GROUP = 'CLEAR_CREATED_CUSTOM_GROUP';
export const CREATE_CUSTOM_GROUP = 'CREATE_CUSTOM_GROUP';
export const SAVE_CUSTOM_GROUP = 'SAVE_CUSTOM_GROUP';
export const SAVE_CUSTOM_GROUP_SUCCESS = 'SAVE_CUSTOM_GROUP_SUCCESS';
export const SAVE_CUSTOM_GROUP_FAILURE = 'SAVE_CUSTOM_GROUP_FAILURE';
export const EDIT_CUSTOM_GROUP = 'EDIT_CUSTOM_GROUP';
export const EDIT_CUSTOM_GROUP_SUCCESS = 'EDIT_CUSTOM_GROUP_SUCCESS';
export const EDIT_CUSTOM_GROUP_FAILURE = 'EDIT_CUSTOM_GROUP_FAILURE';
export const DELETE_CUSTOM_GROUP = 'DELETE_CUSTOM_GROUP';
export const DELETE_CUSTOM_GROUP_SUCCESS = 'DELETE_CUSTOM_GROUP_SUCCESS';
export const DELETE_CUSTOM_GROUP_FAILURE = 'DELETE_CUSTOM_GROUP_FAILURE';
export const FETCH_CUSTOM_GROUP_ITEM_TYPES = 'FETCH_CUSTOM_GROUP_ITEM_TYPES';
export const FETCH_CUSTOM_GROUP_ITEM_TYPES_SUCCESS = 'FETCH_CUSTOM_GROUP_ITEM_TYPES_SUCCESS';
export const FETCH_CUSTOM_GROUP_ITEM_TYPES_FAILURE = 'FETCH_CUSTOM_GROUP_ITEM_TYPES_FAILURE';
export const ENTER_CUSTOM_GROUP_EDIT_MODE = 'ENTER_CUSTOM_GROUP_EDIT_MODE';
export const EXIT_CUSTOM_GROUP_EDIT_MODE = 'EXIT_CUSTOM_GROUP_EDIT_MODE';
export const SELECT_CUSTOM_GROUP = 'SELECT_CUSTOM_GROUP';
export const SELECT_CUSTOM_GROUP_ITEM_TYPE = 'SELECT_CUSTOM_GROUP_ITEM_TYPE';
export const REFRESH_CUSTOM_GROUP = 'REFRESH_CUSTOM_GROUP';
export const REFRESH_CUSTOM_GROUP_FAILURE = 'REFRESH_CUSTOM_GROUP_FAILURE';
export const REFRESH_CUSTOM_GROUP_SUCCESS = 'REFRESH_CUSTOM_GROUP_SUCCESS';
export const FETCH_USER_PRIVILEGES = 'FETCH_USER_PRIVILEGES';
export const FETCH_USER_PRIVILEGES_SUCCESS = 'FETCH_USER_PRIVILEGES_SUCCESS';
export const FETCH_USER_PRIVILEGES_FAILURE = 'FETCH_USER_PRIVILEGES_FAILURE';
export const IS_ARCHIVE_ADMIN = 'IS_ARCHIVE_ADMIN';
